import { useState } from "react";
import { login } from "../api";
import { useNavigate } from "react-router";
const logo = new URL("../images/renew-pacific-logo.svg", import.meta.url);

export default function LoginPage() {
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);

        const form = e.target as HTMLFormElement;
        const formData = new FormData(form);
        const username = formData.get('username') as string;
        const password = formData.get('password') as string;

        try {
            await login(username, password);
            navigate('/dashboard');
        } catch (error) {
            setError('Invalid username or password. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="h-screen flex items-center justify-center bg-pacificblue-900">
            <div className="w-3/4 xl:w-1/3 min-h-1/3 flex gap-8 items-center justify-center bg-white rounded-lg p-16">
                <div>
                    <div className="flex items-center justify-center">
                        <img className="mr-4 h-16" src={logo.toString()} alt="REnew Pacific" />
                        <h2 className="text-2xl font-title font-bold text-neutral">
                            Performance Monitoring
                        </h2>
                    </div>

                    <form onSubmit={handleSubmit} className="pt-8">
                        <div className="space-y-6">
                            {error && (
                                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
                                    {error}
                                </div>
                            )}

                            <div>
                                <input
                                    id="username"
                                    name="username"
                                    type="text"
                                    placeholder="Username"
                                    required
                                    disabled={isLoading}
                                    className="w-full text-sm py-1 autofill:!bg-transparent border-b border-pacificblue-900 text-pacificblue-900 placeholder-pacificblue-900/50 outline-none focus:border-b-2 disabled:bg-base-200"
                                />
                            </div>

                            <div>
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    placeholder="Password"
                                    required
                                    disabled={isLoading}
                                    className="w-full text-sm py-1 autofill:!bg-transparent border-b border-pacificblue-900 text-pacificblue-900 placeholder-pacificblue-900/50 outline-none focus:border-b-2 disabled:bg-base-200"
                                />
                            </div>

                            <div className="flex items-center justify-between gap-6">
                                <button
                                    type="button"
                                    onClick={() => window.location.href = '/accounts/password_reset/'}
                                    className="text-sm text-pacificblue-900 hover:text-pacificblue-700 hover:cursor-pointer"
                                >
                                    Reset password
                                </button>
                                <button
                                    type="submit"
                                    disabled={isLoading}
                                    className="py-2 px-4 text-sm font-medium rounded-md bg-pacificgreen-500 hover:bg-pacificgreen-600 text-secondary-content hover:cursor-pointer disabled:bg-base-200 disabled:cursor-not-allowed disabled:text-gray-500"
                                >
                                    {isLoading ? (
                                        <div className="flex items-center">
                                            <span className="loading loading-dots loading-sm mr-2"></span>
                                            Signing in
                                        </div>
                                    ) : ('Sign in')
                                    }
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
} 